import { compose } from 'redux';
import { getKey, splitBy, mapFn, testPattern } from '../utils/fns';

const testIsMobile = testPattern(/Android|iPhone|iPad|Mobile/);
const toNumber = mapFn(Number);
const splitByDot = splitBy('.');
const keys = [
  0,
  1,
  'userAgent',
  'os',
  'browser',
  'version',
  'name',
  'bitratesCut',
  'supportedDrmType',
];
const [
  getFirst,
  getSecond,
  getUserAgent,
  getOS,
  getBrowser,
  getVersion,
  getName,
  getBitratesCut,
  getSupportedDrmTypes,
] = mapFn(getKey)(keys);

export const userAgent = getUserAgent;
export const os = compose(getOS, getUserAgent);
export const osVersion = compose(getVersion, getOS, getUserAgent);
export const osVersionFragments = compose(toNumber, splitByDot, osVersion);
export const osMajorVersion = compose(getFirst, osVersionFragments);
export const osMinorVersion = compose(getSecond, osVersionFragments);
export const osName = compose(getName, getOS, getUserAgent);
export const browserVersion = compose(getVersion, getBrowser, getUserAgent);
export const browserName = compose(getName, getBrowser, getUserAgent);
export const bitratesCut = compose(getBitratesCut, getUserAgent);
export const supportedDrmType = compose(getSupportedDrmTypes, getUserAgent);
// TODO: maybe it would be more accurate to use ua-parser results `device.type` ?
export const isMobile = compose(testIsMobile, getKey('ua'), getUserAgent);
